import styled from 'styled-components';

export const ResponsiveSearchDrawerItemContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  height: fit-content;
  box-shadow: none;
  border: none;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    & > * {
      width: 100% !important;
    }
  }
`;

export const DateSelectionDrawerFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 12px;
  border-top: 1px solid ${({ theme }) => theme.palette.grey300};
  background: ${({ theme }) => theme.palette.white};
`;

export const HotelMobileHolidayPanelLayout = styled.div`
  height: 100%;
  min-height: 0;

  [data-holiday-panel-fills-available-space='true'] {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  [data-fills-available-space='true'] {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
  }
`;

export const ResponsiveHolidayFooterSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 8px;
`;

export const ResponsiveHolidayFooterItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const ResponsiveHolidayFooterDot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  flex: none;
  background-color: ${({ theme }) => theme.palette.coral};
`;
